import styled from 'styled-components';

export const Footer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
`;

export const SpeakerContainer = styled.div`
    display: flex
`;

export const SpeakerNameWrapper = styled.div`
    background: linear-gradient(90deg, #4169E1 0%, #87CEEB 100%);
    padding: 10px;
    width: 65%;
    position: relative;
`;

export const Strip = styled.div`
    width: 25px;
    height: 40px;
    transform: skew(62deg);
    background: #4169E1;
    position: absolute;
    right: -15px;
    top: 0;
`;

export const Triangle = styled.div`
    border-bottom: 40px solid #87CEEB;
    border-right: 75px solid transparent;
`;

export const TxtContainer = styled.div`
    background: #2F2F2FCC;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    margin-bottom: 25px;
    padding: 20px;
    margin-right: 100px;
    display: flex
`;

export const TxtWrapper = styled.div`
    width: 85%;
    display: inline-block;
    position: relative;
`;

export const ImgWrapper = styled.div`
    width: 15%;
    display: inline-block;
    text-align: end
`;

export const MouseImg = styled.img`
    width: 35px; 
    margin-right: 20px
`;

export const SpeakerTxtLabel = styled.p`
    color: #87CEEB;
    font-size: 20px;
    margin: 0;
`;

export const SpeakerNameLabel = styled.span`
    font-weight: bold;
`;

export const ChoiceBtnsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 0;
`;

export const ChoiceBtnWrapper = styled.div`
    display: flex;
    width: max-content;
    position: relative;
`;
